import { useTranslation } from 'react-i18next';
import AgyleButton from '../../../ui/buttons/agyleButton';
import { useDispatch, useSelector } from 'react-redux';
import { agylePref } from '../../../../store/reducers/preferences';
import useOpenState from '../../../../hooks/useOpenState';
import APIForm from '../../../../app/apiForm';
import DescriptionIcon from '@mui/icons-material/Description';
import { setSnackbar } from '../../../../store/reducers/globals';
import { useState } from 'react';
import AgyleDialog from '../../../modal/agyleDialog';
import { ButtonGroup } from '@mui/material';
import { getConfig } from '../../../../util/configUtil';
import {
    changeActiveContextScreen,
    changePatientContextTab,
    ctxCurrentTab,
    ctxSplitScreen,
    setCurrentTab,
    setDorBlob,
    toggleSplitScreen,
} from '../../../../store/reducers/patientContext';
import { PATIENT_CONTEXT_TABS_ID } from '../../../../pages/ward/forms/formsUtil';

const NoteDoRPreview = ({ attachment, disabled, patient }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const agylePreference = useSelector(agylePref);
    const splitScreen = useSelector(ctxSplitScreen);
    const currentContextTab = useSelector(ctxCurrentTab);

    const [isConfirmOpen, openConfirm, closeConfirm] = useOpenState(false, false);
    const [loading, setLoading] = useState(false);

    // config
    const splitScreenEnabled = getConfig('modules.splitScreen.enabled', false);

    const getDoR = async () => {
        setLoading(true);

        const dor = await APIForm.generateDoRForClinicalNotes(
            patient?.patient?.__id,
            attachment?.otherData?.attendanceId,
            attachment?.referenceId,
            attachment?.otherData?.formTemplate,
            attachment?.otherData?.version,
        );
        setLoading(false);
        return dor;
    };

    const generateInNewTab = () => {
        closeConfirm();
        getDoR()
            .then((res) => {
                const blob = new Blob([res], { type: 'application/pdf' });
                let objectURL = window.URL.createObjectURL(blob);
                window.open(objectURL, '_blank');
            })
            .catch((e) => {
                console.error(e);
                dispatch(setSnackbar({ type: 'error', message: t('Failed to generate DoR') }));
            });
    };

    const openInIframe = (showInSplitScreen) => {
        closeConfirm();

        getDoR()
            .then((res) => {
                const blob = new Blob([res], { type: 'application/pdf' });
                let objectURL = window.URL.createObjectURL(blob);
                dispatch(setDorBlob(objectURL));

                if (showInSplitScreen) {
                    if (splitScreen?.enabled) {
                        dispatch(changeActiveContextScreen(PATIENT_CONTEXT_TABS_ID.NOTE_DOCUMENT));
                    } else {
                        dispatch(toggleSplitScreen(PATIENT_CONTEXT_TABS_ID.NOTE_DOCUMENT));
                    }
                } else {
                    dispatch(setCurrentTab(PATIENT_CONTEXT_TABS_ID.NOTE_DOCUMENT));
                }
            })
            .catch((e) => {
                console.error(e);
                dispatch(setSnackbar({ type: 'error', message: t('Failed to generate DoR') }));
            });
    };

    const handleOpenDoR = () => {
        const opt = agylePreference?.dorInClinicalNotes ?? 'ask';

        switch (opt) {
            case 'newTab':
                generateInNewTab();
                break;
            case 'iframe':
                openInIframe(false);
                break;
            case 'splitScreen':
                openInIframe(true);
                break;
            case 'ask':
            default:
                openConfirm();
                break;
        }
    };

    return (
        <>
            <AgyleButton variant="text" disabled={disabled} onClick={handleOpenDoR} startIcon={<DescriptionIcon />} loading={loading}>
                {t('View DoR')}
            </AgyleButton>

            <AgyleDialog title={t('Choose action')} onClose={closeConfirm} open={isConfirmOpen} width="sm" closeButtonOnHeader disableSave>
                <>
                    <ButtonGroup fullWidth>
                        <AgyleButton onClick={generateInNewTab} variant="contained">
                            {t('Open in new tab')}
                        </AgyleButton>
                        <AgyleButton onClick={() => openInIframe(false)} variant="contained">
                            {t('Open in iFrame')}
                        </AgyleButton>
                        {splitScreenEnabled && (
                            <AgyleButton variant="contained" onClick={() => openInIframe(true)}>
                                {t('Open in Split screen')}
                            </AgyleButton>
                        )}
                    </ButtonGroup>
                </>
            </AgyleDialog>
        </>
    );
};

export default NoteDoRPreview;
